var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backTop",on:{"click":_vm.goTop}},[_c('div',{staticClass:"icon-share"})])
}
var staticRenderFns = []

export { render, staticRenderFns }